import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DataSharingService } from './data-sharing.service';
import {
  CoordinatorPanelRole,
  isCoordinatorPanelAccessDenied,
} from './role-route.util';
import { navigateToForbidden } from './token.util';

export const coordinatorPanelRoleGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const dataSharing = inject(DataSharingService);
  const requiredPanelRole = route.data['panelRole'] as CoordinatorPanelRole;

  if (!requiredPanelRole) {
    return true;
  }

  if (
    isCoordinatorPanelAccessDenied(
      dataSharing.clientRole,
      requiredPanelRole
    )
  ) {
    navigateToForbidden(router);
    return false;
  }

  return true;
};
